module.exports = __webpack_public_path__ + "static/media/stack-overflow.2e930bb1.svg";